import { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import TextButton from "@shared/v2/TextButton";
import Tooltip from "@shared/v2/Tooltip";
import ViewAllListingAlertsModal from "../modals/ViewAllListingAlertsModal";
import AddListingAlertModal from "../modals/AddListingAlertModal";
import EditListingAlertModal from "../modals/EditListingAlertModal";
import { getAlerts } from "./service";

const AllListingAlertPreview = ({ person, emailDetails, geoCodeAccountAddress }) => {
  const [editListingAlertModalOpen, setEditListingAlertModalOpen] = useState(false);
  const [addListingAlertModalOpen, setAddListingAlertModalOpen] = useState(false);
  const [listingAlertsModalOpen, setListingAlertsModalOpen] = useState(false);
  const [indexOfAlertToEdit, setIndexOfAlertToEdit] = useState(0);
  const [listingAlerts, setListingAlerts] = useState([]);
  const [mlsIds, setMlsIds] = useState([]);
  const [websiteUrl, setWebsiteUrl] = useState("");

  const openListingAlertModal = async () => {
    if (emailDetails) {
      const response = await getAlerts(person.slug);
      setListingAlerts(response.data.alerts);
      setWebsiteUrl(response.data.website_url);
      setMlsIds(response.data.mls_ids);
      setListingAlertsModalOpen(true);
    }
  };

  const closeListingAlertModal = () => {
    setListingAlertsModalOpen(false);
  };

  const closeEditListingAlertModal = () => {
    setEditListingAlertModalOpen(false);
    setIndexOfAlertToEdit(0);
  };

  const deleteAlert = (alertIndex) => {
    const { alertId } = listingAlerts[alertIndex];
    const url = `/people/${person.id}/listing_alerts/${alertId}`;
    axios
      .delete(url, { params: { authenticity_token: ReactOnRails.authenticityToken() } })
      .then(() => {
        setListingAlerts(listingAlerts.filter((alert) => alert.alertId !== alertId));
      })
      .catch((response) => console.log(response));
  };

  const openEditFromViewAll = (alertIndex) => {
    setIndexOfAlertToEdit(alertIndex);
    setEditListingAlertModalOpen(true);
    setListingAlertsModalOpen(false);
  };

  const openAddFromViewAll = () => {
    setListingAlertsModalOpen(false);
    setAddListingAlertModalOpen(true);
  };

  const tooltipDescription = () => {
    const hasActiveIdxAlerts = person.active_idx_alerts && person.active_idx_alerts > 0;
    const hasIdxAlerts = person.idx_alerts && person.idx_alerts > 0;
    if (hasActiveIdxAlerts) {
      return "Listing Alerts sending";
    }
    if (hasIdxAlerts) {
      return "Not sending Listing Alerts";
    }
    return "No Listing Alerts";
  };

  const getColorStyle = () => {
    const hasActiveIdxAlerts = person.active_idx_alerts && person.active_idx_alerts > 0;
    const hasIdxAlerts = person.idx_alerts && person.idx_alerts > 0;
    if (hasActiveIdxAlerts) {
      return "";
    }
    if (hasIdxAlerts) {
      return "!tw-text-brand-danger";
    }
    return "!tw-text-gray-50";
  };

  const closeAddListingAlertModal = () => {
    setAddListingAlertModalOpen(false);
    setIndexOfAlertToEdit(0);
  };

  return (
    <>
      <Tooltip
        trigger={
          <TextButton
            disabled={!emailDetails}
            className={getColorStyle()}
            size="medium"
            onClick={openListingAlertModal}
          >
            {person.idx_alerts || 0}
          </TextButton>
        }
        content={tooltipDescription()}
        placement="right"
      />
      {listingAlertsModalOpen && (
        <ViewAllListingAlertsModal
          onClose={closeListingAlertModal}
          listingAlerts={listingAlerts}
          openEditModal={openEditFromViewAll}
          handleDelete={deleteAlert}
          mlsIds={mlsIds}
          websiteUrl={websiteUrl}
          openAddModal={openAddFromViewAll}
        />
      )}
      {addListingAlertModalOpen && (
        <AddListingAlertModal
          person={person}
          closeListingAlertModal={closeAddListingAlertModal}
          mlsIds={mlsIds}
          geoCodeAccountAddress={geoCodeAccountAddress}
        />
      )}
      {editListingAlertModalOpen && (
        <EditListingAlertModal
          person={person}
          closeListingAlertModal={closeEditListingAlertModal}
          alert={listingAlerts[indexOfAlertToEdit]}
          mlsIds={mlsIds}
          geoCodeAccountAddress={geoCodeAccountAddress}
        />
      )}
    </>
  );
};

AllListingAlertPreview.propTypes = {
  person: PropTypes.shape().isRequired,
  emailDetails: PropTypes.shape(),
  geoCodeAccountAddress: PropTypes.string,
};

AllListingAlertPreview.defaultProps = {
  emailDetails: null,
  geoCodeAccountAddress: "",
};

export default AllListingAlertPreview;
